import React, { memo } from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";

// One spatial-nav focusable key. Memoized so a query change never re-renders
// the whole grid — only the focused key toggles its class.
const KeyboardKey = memo(({ label, value, focusKey, onPress, icon, wide, full }) => {
    const { ref, focused } = useFocusable({
        focusKey,
        onEnterPress: () => onPress(value),
    });

    const cls = ["kbKey", wide && "kbKey--wide", full && "kbKey--full", focused && "focused"]
        .filter(Boolean)
        .join(" ");

    return (
        <button ref={ref} className={cls} onClick={() => onPress(value)} tabIndex={-1} aria-label={label}>
            {icon && <img src={icon} alt="" className="kbKey__icon" />}
            {label}
        </button>
    );
});

export default KeyboardKey;
